import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';

import DeviceLinkCell from '../../Cells/LinkCell/DevicesLinkCall';
import ActionCell from '../../Cells/ActionCell/ActionCell';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { SmartSnapTrapData } from 'api/traps/STTraps/types';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface STRExpandableProps {
  data: SmartSnapTrapData;
  slug?: string;
}
const STRExpandable: React.FC<STRExpandableProps> = ({ data, slug }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.Action')}</span>
          </div>
          <div>
            <ActionCell
              qrCodeOptions={{ msg: `Device Serial Number: ${data.serial_number}`, qr_code: data.qr_code }}
              trap={{ pk: data.id, serialNumber: data.serial_number || '' }}
              slug={slug}
            />
          </div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
            <div>
              <DeviceLinkCell
                data={data.default_plan ?? null}
                icon="ri-treasure-map-line"
                slug={slug}
                deviceType={TrapTableTypeLink.SnapTrapRat}
                device_add_slug={data.slug}
              />
            </div>
          </div>
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-wrap gap-2 justify-content-center my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.LastConnection')}: `}</span>
            {dayjs(data?.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
              ? dayjs(data?.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
              : '-'}
          </div>
        </div>
      )}
    </div>
  );
};

export default STRExpandable;
